import React, { useEffect, useState } from "react";
import { ReactComponent as PlusIcon } from "../../images/plus-icon.svg";
import { ReactComponent as DeleteIcon } from "../../images/delete-icon.svg";
import styled from "styled-components";
import DeletePost from "../Popup/DeletePost";
import { DELETE_TICKET } from "../../mutation/DeleteEventTicket";
import { hasuraClient } from "../../apolloClient";
import { useMutation } from "@apollo/client";

const TicketTypePara = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  margin-top: 30px;
  color: rgba(105, 106, 231, 1);
`;

const TicketTypeButton = styled.button`
  width: 130px;
  height: 100%;
  max-height: 45px;
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background: transparent;
  align-items: center;
  justify-content: center;
  border: 1px solid #989db2;
  margin-right: 20px;
`;

const TicketTypeButtonSelected = styled.button`
  width: 130px;
  height: 100%;
  max-height: 45px;
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background: transparent;
  align-items: center;
  justify-content: center;
  border: 1px solid blue;
  margin-right: 20px;
  pointer-events: none;
  cursor: not-allowed;
`;

const TicketType = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0px;
  text-align: center;
  color: rgba(22, 31, 61, 1);
  margin-bottom: 0;
`;

const TicketTableHead = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 678px;
  height: 45px;
  margin-top: 26px;
  background: rgba(231, 233, 241, 0.5);
  margin: 26px 0 0 0px;
`;
const TicketDetailDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 12px;
  padding: 0 0px;
`;

const EventTickets = (props) => {
  const { step2Data, setStep2Value } = props;
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    if (step2Data) {
      localStorage.setItem(
        "event_data",
        JSON.stringify(step2Data?.event_paid_ticket_details)
      );

      let arr = [],
        arr2 = JSON.parse(localStorage.getItem("event_data"));

      for (let i = 0; i < arr2.length; i++) {
        arr.push(arr2[i]);
      }

      setTickets(arr);
    }
  }, [step2Data]);

  const [DeleteTicket] = useMutation(DELETE_TICKET, {
    client: hasuraClient,
  });

  const [showticketOption, setShowTicketOption] = useState(
    step2Data ? false : true
  );
  const [ticketRequireError, setTicketRequireError] = useState(false);
  const [ticketPaidGreatError, setPaidTicketGreatError] = useState(false);
  const [ticketFreeGreatError, setFreeTicketGreatError] = useState(false);
  const [oldTicketError, setOldTicketError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const [isFreeTicket, setIsFreeTicket] = useState(
    step2Data
      ? step2Data.event_payment_type === "free" 
        ? true
        : false
      : false
  );

  const [isNoTicket, setIsNoTicket] = useState(
    step2Data
      ? (step2Data.event_payment_type === "free" && !step2Data.event_paid_ticket_details.length >0) ||
        (step2Data?.event_payment_type?.includes("free") && !step2Data.event_paid_ticket_details.length>0)
        ? true
        : false
      : false
  );
  const [isPaidTicket, setIsPaidTicket] = useState(
    step2Data
      ? step2Data.event_payment_type[0] === "paid" || step2Data.event_payment_type==="paid" ?
         true
        : false
      : false
  );

  const [ticketsError, setTicketsError] = useState([]);
  const [duplicateError, setDuplicateError] = useState(false);

  const [selectTicketError, setSelectTicketError] = useState(false);

  const urlPattern = new RegExp(
    '^(https?:\/\/)?([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}(\S*)$'
  ); 
  const freeTicketType = () => {
    setSelectTicketError(false);
    var allTickets = [...tickets];
    const ticket = {
      option_name: "",
      quantity_available: "",
      description: " ",
      price: 0,
    };
    allTickets.push(ticket);
    setTickets(allTickets);
    setIsFreeTicket(false);
    setShowTicketOption(false);
    return null;
  };

  const paidTicketType = () => {
    setSelectTicketError(false);
    var allTickets = [...tickets];
    const ticket = {
      option_name: "",
      quantity_available: "",
      description: " ",
      price: "",
    };
    allTickets.push(ticket);
    setTickets(allTickets);
    setIsPaidTicket(true);
    setShowTicketOption(false);
    return null;
  };

  const noTicketType = () => {
  //   if(isPaidTicket||isFreeTicket ===true){
  //   setSelectTicketError(false);
  //   setIsNoTicket(!isNoTicket);
  //   setShowTicketOption(true);
  //   setIsPaidTicket(false);
  //   setIsFreeTicket(false);
  // }else{
    setSelectTicketError(false);
    setIsNoTicket(!isNoTicket);
    setShowTicketOption(false);
    setIsPaidTicket(false);
    setIsFreeTicket(false);
  // }
    return null;
  };

  const typeOfTicket = () => {
    if (showticketOption && !isNoTicket) {
      return (
        <div style={{ padding: "0 0px" }}>
          <TicketTypePara>
            What type of ticket would you like to{" "}
            {tickets.length > 0 ? "add" : "start with"}?
          </TicketTypePara>
          <div style={{ display: "flex", flexDirection: "row", marginTop: 12 }}>
            {isFreeTicket === false && isPaidTicket === false && isNoTicket === false ? (
              <>
                <TicketTypeButton onClick={freeTicketType}>
                  <span>
                    <PlusIcon style={{ width: 12, marginRight: 7 }} />
                  </span>
                  <TicketType>Free Ticket</TicketType>{" "}
                </TicketTypeButton>
                <TicketTypeButton onClick={paidTicketType}>
                  <span>
                    <PlusIcon style={{ width: 12, marginRight: 7 }} />
                  </span>
                  <TicketType>Paid Ticket</TicketType>{" "}
                </TicketTypeButton>
                <TicketTypeButton onClick={noTicketType}>
                  <span>
                    <PlusIcon style={{ width: 12, marginRight: 7 }} />
                  </span>
                  <TicketType>No Ticket</TicketType>{" "}
                </TicketTypeButton>
              </>
            ) : isFreeTicket ? (
              <TicketTypeButton onClick={freeTicketType}>
                <span>
                  <PlusIcon style={{ width: 12, marginRight: 7 }} />
                </span>
                <TicketType>Free Ticket</TicketType>{" "}
              </TicketTypeButton>
            ) : isPaidTicket ? (
              <TicketTypeButton onClick={paidTicketType}>
                <span>
                  <PlusIcon style={{ width: 12, marginRight: 7 }} />
                </span>
                <TicketType>Paid Ticket</TicketType>{" "}
              </TicketTypeButton>
            ) : isNoTicket ? (
              <TicketTypeButton onClick={noTicketType}>
                <span>
                  <PlusIcon style={{ width: 12, marginRight: 7 }} />
                </span>
                <TicketType>No Ticket</TicketType>{" "}
              </TicketTypeButton>
            ) : null}
          </div>
          <p hidden={!selectTicketError} className="error-message">
            Please select ticket
          </p>
        </div>
      );
    } 
    else if(isPaidTicket){
        return (
          <div style={{ padding: "0 10px" }}>
            <TicketTypePara
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectTicketError(false);
                if (isPaidTicket) {
                  paidTicketType();
                } else if (isFreeTicket) {
                  freeTicketType();
                } else {
                  setShowTicketOption(true);
                }
              }}
            >
              + Add ticket option
            </TicketTypePara>
          </div>
        );
    }
    else if(!isNoTicket){
      <TicketTypeButtonSelected onClick={noTicketType}>
              <span>
                <PlusIcon style={{ width: 12, marginRight: 7 }} />
              </span>
              <TicketType>No Ticket</TicketType>{" "}
      </TicketTypeButtonSelected>
    }
  };

  const handleDeleteTicket = (index) => {
    setPaidTicketGreatError(false);
    setFreeTicketGreatError(false);
    setTicketRequireError(false);

    if (tickets[index]?.id) {
      DeleteTicket({
        variables: {
          id: tickets[index]?.id,
        },
      }).catch(() => {});
    }

    const options = tickets.filter((items, itemIndex) => itemIndex !== index);
    setTickets([]);
    setTickets(options);
    if (options?.length === 0) {
      setIsFreeTicket(false);
      setIsPaidTicket(false);
      setShowTicketOption(true);
    }
  };

  const ticketsDetails = () => {
    return (
      <div>
        {tickets.length > 0
          ? tickets.map((ticket, index) => {
              return (
                <TicketDetailDiv key={Math.random(0, 999999)}>
                  <div>
                    <input
                      type="text"
                      className="lg-form-control"
                      defaultValue={
                        ticket.option_name != "" ? ticket.option_name : null
                      }
                      style={{ width: 312, marginRight: 15 }}
                      onChange={(e) => {
                        tickets[index].option_name = e.target.value;
                        setTicketRequireError(false);
                      }}
                      disabled={props?.data?.events_by_pk?.id && ticket?.id}
                    />
                    {ticketsError?.name?.length > 0 &&
                      ticketsError?.name[index] && (
                        <p className="error-message">Ticket Name required</p>
                      )}
                  </div>
                  <div>
                    <input
                      type="number"
                      className="lg-form-control"
                      defaultValue={
                        ticket.quantity_available != ""
                          ? ticket.quantity_available
                          : null
                      }
                      style={{ width: 152, marginRight: 15 }}
                      onChange={(e) => {
                        tickets[index].quantity_available = e.target.value;
                        setTicketRequireError(false);
                        setPaidTicketGreatError(false);
                        setFreeTicketGreatError(false);
                        setOldTicketError(false);
                      }}
                    />
                    {ticketsError?.quantity?.length > 0 &&
                      ticketsError?.quantity[index] && (
                        <p className="error-message">
                          {ticketsError?.quantity[index] === "required"
                            ? "Quantity required"
                            : "Qty has to be more than one"}
                        </p>
                      )}
                  </div>
                  <div>
                    <input
                      type="number"
                      className="lg-form-control"
                      defaultValue={ticket.price}
                      style={{ width: 185 }}
                      disabled={ticket.price === 0 ? true : false}
                      onChange={(e) => {
                        tickets[index].price = e.target.value;
                        setPaidTicketGreatError(false);
                        setFreeTicketGreatError(false);
                        setOldTicketError(false);
                      }}
                    />

                    {ticketsError?.price?.length > 0 &&
                      ticketsError?.price[index] && (
                        <p className="error-message">
                          {ticketsError?.price[index] === "required"
                            ? "Price required"
                            : "Price has to be more than one"}
                        </p>
                      )}
                  </div>
                  {!props?.data?.events_by_pk?.id ? (
                    <div
                      style={{
                        marginLeft: 18,
                        marginTop: 7,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleDeleteTicket(index);
                      }}
                    >
                      <DeleteIcon />
                    </div>
                  ) : null}
                </TicketDetailDiv>
              );
            })
          : null
        }
      </div>
    );
  };

  const handleNext = () => {
    let arr = [];

    for (let i = 0; i < tickets.length; i++) {
      if (tickets[i].id) {
        arr.push(tickets[i]);
      }
    }

    let isSubmit = true;

    if (arr.length) {
      for (let i = 0; i < arr.length; i++) {
        if (
          arr[i].price >=
            props?.data?.events_by_pk?.event_paid_ticket_details[i]?.price &&
          arr[i].quantity_available >=
            props?.data?.events_by_pk?.event_paid_ticket_details[i]
              ?.quantity_available &&
          props?.data?.events_by_pk?.event_payment_type === "paid"
        ) {
          isSubmit = true;
        } else if (
          arr[i].quantity_available >=
            props?.data?.events_by_pk?.event_paid_ticket_details[i]
              ?.quantity_available &&
          props?.data?.events_by_pk?.event_payment_type === "free"
        ) {
          isSubmit = true;
        } else {
          isSubmit = false;
          setOldTicketError(true);
          break;
        }
      }
    }

    if (isSubmit) {
      const finalValues = [];

      if (tickets?.length === 0 && !isNoTicket) {
        setSelectTicketError(true);
        return false;
      }

      if (tickets?.length === 1 && tickets[0]?.price === 0) {
        if (!tickets[0]?.option_name || !tickets[0]?.quantity_available) {
          setTicketRequireError(true);
          return false;
        } else if (tickets[0]?.quantity_available <= 0) {
          setFreeTicketGreatError(true);
          return false;
        }
      } else {
        for (let i = 0; i < tickets?.length; i++) {
          if (
            !tickets[i]?.option_name ||
            !tickets[i]?.quantity_available ||
            !tickets[i]?.price
          ) {
            setTicketRequireError(true);
            return false;
          } else if (
            tickets[i]?.quantity_available <= 0 ||
            tickets[i]?.price <= 0
          ) {
            setPaidTicketGreatError(true);
            return false;
          }
        }
      }

      var valueArr = tickets.map(function (item) {
        return item.option_name;
      });
      var isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item.trimStart().trimEnd()) != idx;
      });

      const optionName = [];
      const quantityAvailable = [];
      const price = [];

      tickets?.map((d) => {
        optionName.push(d?.option_name === "" ? true : false);
        price.push(
          isPaidTicket
            ? d?.price === ""
              ? "required"
              : d?.price > 0 || d?.price > "0"
              ? false
              : true
            : false
        );
        quantityAvailable.push(
          d?.quantity_available === ""
            ? "required"
            : d?.quantity_available > 0 || d?.quantity_available > "0"
            ? false
            : true
        );
      });

      const ticketsErrorVal = {
        name: optionName,
        quantity: quantityAvailable,
        price: price,
      };
      setTicketsError(ticketsErrorVal);

      if (isDuplicate) {
        setDuplicateError(true);
      } else {
        setDuplicateError(false);
      }

      if (
        isDuplicate === true ||
        ticketsError?.name?.includes(true) ||
        ticketsError?.quantity?.includes(true) ||
        ticketsError?.price?.includes(true) ||
        ticketsError?.quantity?.includes("required") ||
        ticketsError?.price?.includes("required")
      ) {
        return false;
      }

      if(tickets?.length === 0){
        finalValues.event_paid_ticket_details = [...tickets];
        finalValues.event_payment_type = "free";
        let totalAttendees = 0;
        tickets.map((ticket) => {
          totalAttendees += parseInt(ticket.quantity_available);
        });
        finalValues.total_attendees = totalAttendees;
        finalValues.is_ticket_required = true;
        setStep2Value(finalValues);
        if (props?.modalShowD) {
          props.onPressYes(false, finalValues);
        } else {
          props.handleNext();
        }
      }
      else if(tickets?.length !==0 && tickets[0]?.price === 0) {
        finalValues.event_paid_ticket_details = [...tickets];
        finalValues.event_payment_type = "free";
        let totalAttendees = 0;
        tickets.map((ticket) => {
          totalAttendees += parseInt(ticket.quantity_available);
        });
        finalValues.total_attendees = totalAttendees;
        finalValues.is_ticket_required = false;
        setStep2Value(finalValues);
        if (props?.modalShowD) {
          props.onPressYes(false, finalValues);
        } else {
          props.handleNext();
        }
      } else if(tickets?.length !==0 && tickets[0]?.price !== 0){
        finalValues.event_paid_ticket_details = [...tickets];
        finalValues.event_payment_type = "paid";
        let totalAttendees = 0;
        tickets.map((ticket) => {
          totalAttendees += parseInt(ticket.quantity_available);
        });
        finalValues.total_attendees = totalAttendees;
        finalValues.is_ticket_required = false;
        setStep2Value(finalValues);
        if (props?.modalShowD) {
          props.onPressYes(false, finalValues);
        } else {
          props.handleNext();
        }
      }
    }
  };
  const handleBack = () => {
    const finalValues = [];
    finalValues.event_paid_ticket_details = [...tickets];
    if(tickets.length===0){
      finalValues.event_payment_type = ["free"];
    }
    if (tickets?.length > 0) {
      if (tickets[0].price === 0) {
        finalValues.event_payment_type = ["free"];
      } else {
        finalValues.event_payment_type = ["paid"];
      }
    }

    let totalAttendees = 0;
    tickets.map((ticket) => {
      totalAttendees += parseInt(ticket.quantity_available);
    });
    finalValues.total_attendees = totalAttendees;
    setStep2Value(finalValues);
    props.handleBack();
  };

  return (
    <div className="event-list-cover typeofevent-row" style={{ marginTop: 40 }}>
      <DeletePost
        title={"Your changes will be saved. Are you sure you want to exit?"}
        cancelButtonText={"No"}
        deletePostHandler={handleNext}
        show={props?.modalShowD}
        onHide={props?.onPressNo}
      />
      <div className="title">
        <h3>Create tickets</h3>
        <p>Choose the one that makes most sense for your event. </p>
      </div>
      {tickets.length > 0 ? (
        <TicketTableHead>
          <p style={{ marginRight: 207, marginBottom: 0, marginLeft: 19 }}>
            Ticket name*
          </p>
          <p style={{ marginRight: 93, marginBottom: 0 }}>Quantity*</p>
          <p style={{ marginBottom: 0 }}>Price</p>
        </TicketTableHead>
      ) :  isNoTicket ?<TicketTypeButtonSelected onClick={noTicketType}>
      <span>
        <PlusIcon style={{ width: 12, marginRight: 7 }} />
      </span>
      <TicketType>No Ticket</TicketType>{" "}
    </TicketTypeButtonSelected> : null}
      {ticketsDetails()}

      {oldTicketError ? (
        <p className="error-message">
          *Old Tickets Price and Quantity cannot be less than previous value
        </p>
      ) : (
        ""
      )}

      {ticketRequireError ? (
        <p className="error-message">*All fields are required</p>
      ) : (
        ""
      )}

      {ticketPaidGreatError ? (
        <p className="error-message">
          *Quantity and Price should be grater than 0
        </p>
      ) : (
        ""
      )}

      {ticketFreeGreatError ? (
        <p className="error-message">*Quantity should be grater than 0</p>
      ) : (
        ""
      )}

      <p hidden={!duplicateError} className="error-message">
        Ticket is duplicate
      </p>

      {typeOfTicket()}
      {isNoTicket ||isPaidTicket ? <div
        className="title"
        style={{ padding: "0 10px 0 10px", marginTop: 80 }}
      >
        <h3>External URL or External Ticket (Optional)</h3>
        <p>
        Add a link to an external website to showcase Events or help users access external ticket purchasing.
        </p>
        <input
          type="text"
          className="lg-form-control"
          style={{ width: 673 }}
          placeholder="Ticket URL"
          onChange={(e) => {
            const inputUrl = e.target.value;
            props.setTicketUrl(inputUrl);
            setErrorMessage("")
            if (inputUrl && !urlPattern.test(inputUrl)) {
              // If inputUrl has value and doesn't match the regex pattern, set an error message.
              setErrorMessage("Please enter a valid URL.");
            }
          }}
          value={props.ticketUrl || ""}
        />
         {errorMessage ? <div className="error" style={{ color: "red",fontSize:"14px",marginTop:"5px" }}>Please Enter a valid URL.</div>:null}
      </div> : null}
      <div className="event-button-row">
        <button className="back-btn" onClick={handleBack}>
          Back
        </button>
        <button className="next-btn" onClick={handleNext} disabled={errorMessage === true}>
          Next
        </button>
      </div>
    </div>
  );
};

export default EventTickets;
